import type { FC } from 'react';
import React from 'react';

import type { BaseSvgProps } from '../../utils';
import { sizeToSvgWidth } from '../../utils';

export const FragmentLogoCircle: FC<BaseSvgProps> = ({
  width = sizeToSvgWidth.sm,
  'data-testid': testId = 'paymentbadge',
}) => (
  <svg
    width={width}
    height={width}
    className="block shrink-0 overflow-visible"
    data-testid={testId}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="6" cy="6" r="6" fill="rgb(var(--colour-main))" />
    <path
      transform="translate(-3.76 -3.76) scale(0.064)"
      d="M116.278 202.188V102.812H188.722V115.767H131.278V144.745H181.904V157.699H131.278V202.188H116.278Z"
      fill="rgb(var(--colour-canvas))"
    />
  </svg>
);
